export default "__VITE_ASSET__a55721b7__"